
 
const API_LINK = 'https://dashboard.1solardirect.com/api/';
export default API_LINK;
